import { createResource } from 'redux-rest-resource';
import { HEADERS as headers, BANKS_URL } from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'bank',
  url: `${BANKS_URL}/:id`,
  headers,
  actions: {
    createMany: {
      gerundName: 'creatingMany',
      isArray: true,
      method: 'POST',
      url: `${BANKS_URL}/many`,
    },
    fetch: {
      transformResponse,
    },
  },
});
